import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useLanguage } from '../context/LanguageContext';

const scroll = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
`;

const Strip = styled.div`
  background: #7C3A00;
  border-top: 1px solid rgba(255,220,140,0.2);
  border-bottom: 1px solid rgba(255,220,140,0.2);
  padding: 22px 0;
  overflow: hidden;
  white-space: nowrap;
  user-select: none;
`;

const Track = styled.div`
  display: inline-flex;
  animation: ${scroll} 32s linear infinite;
`;

const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 32px;
  padding: 0 40px;
  font-family: 'Raleway', serif;
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.18em;
  color: rgba(255,253,247,0.92);
  text-transform: uppercase;
`;

const Dot = styled.span`
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255,240,200,0.7);
  flex-shrink: 0;
`;

const highlights = [
  { en: "100% Cow's Milk",    es: '100% Leche de Vaca',  fr: '100% Lait de Vache'      },
  { en: 'No Preservatives',   es: 'Sin Conservadores',   fr: 'Sans Conservateurs'       },
  { en: 'Handcrafted Recipe', es: 'Receta Artesanal',    fr: 'Recette Artisanale'       },
  { en: 'Rich & Versatile',   es: 'Rica y Versátil',     fr: 'Riche & Polyvalente'      },
  { en: 'Since 1950',         es: 'Desde 1950',          fr: 'Depuis 1950'              },
  { en: 'Jalisco, México',    es: 'Jalisco, México',     fr: 'Jalisco, Mexique'         },
  { en: 'FDA Registered',     es: 'Registro FDA',        fr: 'Enregistré FDA'           },
];

export function Highlights() {
  const { t } = useLanguage();
  const items = [...highlights, ...highlights];

  return (
    <Strip id="highlights" aria-hidden="true">
      <Track>
        {items.map((h, i) => (
          <Item key={i}>
            {t(h.en, h.es, h.fr)}
            <Dot />
          </Item>
        ))}
      </Track>
    </Strip>
  );
}

